// @flow
import React from 'react';
import classNames from 'classnames';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import arrowLongRight from 'assets/images/RIGHT.png';
// eslint-disable-next-line
import styles from "./styles.scss";

type Props = {
  imageUrl: string,
  title: string,
  onClick: () => void,
  containerClass?: string,
  buttonText?: string,
};

const DEFAULT_BUTTON_TEXT = 'Explore';

export const AnnouncementCard = (props: Props) => {
  const {
    imageUrl,
    title,
    onClick,
    containerClass = '',
    buttonText,
    // buttonText = DEFAULT_BUTTON_TEXT,
  } = props;

  const containerClassName = classNames('announcement-card', containerClass);

  return (
    <TransitionGroup className={containerClassName}>
      <CSSTransition
        key={imageUrl}
        classNames="announcement-card-animation"
        onClick={onClick}
        timeout={300}
      >
        <>
          <div className="image-container">
            <img src={imageUrl} alt="announcement-image" />
          </div>
          <div className="title-container">
            <h4>{title}</h4>
            {buttonText && (
              <div onClick={onClick}>
                <span className={'call-to-action'}>{buttonText}</span>
                <img className={''} src={arrowLongRight} alt="icon" />
              </div>
            )}
          </div>
        </>
      </CSSTransition>
    </TransitionGroup>
  );
};
